import { Country } from '../models';

export const getCountries = async (): Promise<Country[]> => {
  const countriesFile = await import('../json/countries.min.json');
  return countriesFile.default;
};
